// src/pages/Home.js
import React from "react";
import HeroSection from "../components/HeroSection";
import About from "./About";
import Services from "./Services";
import GallerySection from "../components/GallerySection";
import InstagramFeed from "../components/InstagramFeed";
import Contact from "../components/Contact";
import CarouselSection from "../components/CarouselSection"; // Certifique-se de importar corretamente

const Home = () => {
  return (
    <>
      <HeroSection />
      <section id="about">
        <About />
      </section>
      <section id="services">
        <Services />
      </section>
      <section id="carousel">
        {" "}
        {/* Certifique-se de adicionar esta seção */}
        <CarouselSection />
      </section>
      <section id="gallery">
        <GallerySection />
      </section>
      <InstagramFeed />
      <section id="contact">
        <Contact />
      </section>
    </>
  );
};

export default Home;
